import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

/** Builds the stable public path shared by localized campaign landing pages. */
export function buildLandingPagePath(locale: ViewerLocale, slug: string): string {
  return `/${locale}/pages/${encodeURIComponent(slug)}`;
}
